import Swiper, {Navigation,Grid} from "../../assets/.npm/node_modules/swiper";

export default () => {
  let swiperGal = new Swiper(".slider-gallery", {
    modules: [Navigation,Grid],
    slidesPerView: 1, 
    spaceBetween: 0,
    grid: {
        rows: 2,
        fill: 'row'
    },
    loop: true,
    navigation: {
      nextEl: ".gallery-next",
      prevEl: ".gallery-prev",
    }, 
    breakpoints: {
        580: {
            slidesPerView: 2,
            spaceBetween: 30,
        },
        992: {
            slidesPerView: 3,
            spaceBetween: 30,
        },
    },
  });
}
  
